import styles from '../knowledge.module.scss';
import { scrollTo } from 'src/utils';
import classNames from 'classnames';
import { ListItemsNavigator } from 'src/components/common/items-navigator';
import { useEffect } from 'react';
import { useState } from 'react';

export function RenderSectionList({ sections = [] }) {
  const [activeHash, setActiveHash] = useState(window.location.hash);

  useEffect(() => {
    const handleHashChange = () => setActiveHash(window.location.hash);
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const handleClick = (e, href) => {
    e.preventDefault();
    scrollTo(href, { block: 'end', inline: 'start' });
    window.location.hash = href;
  };

  return (
    <ListItemsNavigator orientation="vertical" className={styles.navigatorContent}>
      {sections?.map(({ title, id }) => {
        const href = `#${id}`;
        const isActive = activeHash === href;
        return (
          <a
            key={id}
            href={href}
            className={classNames(styles.sectionLink, {
              [styles.sectionLinkActive]: isActive,
            })}
            onClick={e => handleClick(e, href)}
          >
            {title}
          </a>
        );
      })}
    </ListItemsNavigator>
  );
}
